import {
  Box,
  Button,
  Stack,
  styled,
  Typography,
  useTheme,
} from "@mui/material";
import AppModal from "components/AppModal";
import PrimaryButton from "components/button/PrimaryButton";
import SecondaryButton from "components/button/SecondaryButton";
import FlexBetween from "components/flexbox/FlexBetween";
import FlexRowAlign from "components/flexbox/FlexRowAlign";
import { TypographyGradient } from "components/Typography";
import { motion, useInView } from "framer-motion";
import { useRef, useState } from "react";
import $ from 'jquery'

const Section = styled("section")(({ theme }) => ({}));

export const Section1 = () => {
  const innerHeight = window.innerHeight;
  const ref = useRef(null);
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const isInView = useInView(ref, {
    once: false,
    margin: `${-innerHeight / 4}px`,
  });

  const handleMove = (id: string) => {
    const sectionTop = $(id).last().offset()?.top
    window.scrollTo({
      top: sectionTop,
      behavior: "smooth"
    });
  }

  return (
    <Section
      ref={ref}
      sx={{
        height: "100vh !important",
        position: "relative",
        scrollSnapAlign: "center",
      }}
    >
      <StyledContainer spacing={{ xs: 4, md: 10 }} pt={{ xs: 0, md: 10 }}>
        <Stack spacing={2} alignItems="center">
          <Stack sx={{ display: { xs: "none", md: "block" } }}>
            <motion.img
              src="logo.svg"
              style={{
                width: "auto",
                height: 50,
              }}
              initial={{
                transform: `scale(4)`,
                opacity: 0,
                filter: `blur(20px)`,
              }}
              animate={{
                transform: `scale(${isInView ? 1 : 4})`,
                opacity: isInView ? 1 : 0,
                filter: `blur(${isInView ? 0 : 20}px)`,
              }}
              transition={{ duration: 0.4 }}
            />
          </Stack>
          <Stack sx={{ display: { xs: "block", md: "none" } }}>
            <motion.img
              src="logo-full.png"
              style={{
                width: "auto",
                height: 50,
              }}
              initial={{
                transform: `scale(4)`,
                opacity: 0,
                filter: `blur(20px)`,
              }}
              animate={{
                transform: `scale(${isInView ? 1 : 4})`,
                opacity: isInView ? 1 : 0,
                filter: `blur(${isInView ? 0 : 20}px)`,
              }}
              transition={{ duration: 0.4 }}
            />
          </Stack>
          <motion.div
            initial={{
              transform: `translateX(-50vw) scaleY(0)`,
              opacity: 0,
            }}
            animate={{
              transform: `translateX(${isInView ? 0 : -50}vw) scaleY(${isInView ? 1 : 0
                })`,
              opacity: isInView ? 1 : 0,
            }}
            transition={{
              type: "spring",
              stiffness: 700,
              damping: 30,
              delay: 0.2,
            }}
          >
            <TypographyGradient
              sx={{
                textTransform: "uppercase",
                fontWeight: 700,
                fontSize: { xs: 17, sm: 24, lg: 48 },
              }}
            >
              REAL YIELD * fee-efficient * Gasless
            </TypographyGradient>
          </motion.div>
          <motion.div
            initial={{
              transform: `translateX(-50vw) scaleY(0)`,
              opacity: 0,
            }}
            animate={{
              transform: `translateX(${isInView ? 0 : -50}vw) scaleY(${isInView ? 1 : 0
                })`,
              opacity: isInView ? 1 : 0,
            }}
            transition={{
              type: "spring",
              stiffness: 700,
              damping: 40,
              delay: 0.25,
            }}
          >
            <Typography
              sx={{ fontSize: { xs: 15, sm: 18, lg: 24 }, fontWeight: 600 }}
            >
              The only perpetual DEX with native yield
            </Typography>
          </motion.div>
          <motion.div
            initial={{
              y: 20,
              opacity: 0,
            }}
            animate={{ y: isInView ? 0 : 20, opacity: isInView ? 1 : 0 }}
            transition={{ duration: 0.2, delay: 0.5 }}
          >
            <SecondaryButton sx={{ borderRadius: 50, paddingX: "1rem" }}>
              <img
                src="static/coins/USDC.svg"
                style={{ width: 30, height: 30 }}
                alt="usdc"
              />
              <Typography
                fontSize={{
                  xs: 15,
                  md: 28,
                  lg: 20,
                }}
                ml={1}
                fontWeight={600}
              >
                USDC 14%
              </Typography>
            </SecondaryButton>
          </motion.div>
        </Stack>
        <Stack spacing={3} alignItems="center" sx={{ zIndex: 10 }}>
          <motion.div
            initial={{
              y: 20,
              opacity: 0,
            }}
            animate={{ y: isInView ? 0 : 20, opacity: isInView ? 1 : 0 }}
            transition={{ duration: 0.2, delay: 0.7 }}
          >
            <PrimaryButton
              onClick={() => handleMove("#airdrop-section")}
              contentSx={{
                [theme.breakpoints.down('sm')]: {
                  transform: 'scale(0.8) translateX(15px)'
                }
              }}
              sx={{
                background:
                  "linear-gradient(10deg,#FA00FF,#B580FF 15%,#FFFFFF 35%,#FFFFFF 80%,#4475F3)",
                width: 300,
                color: "#000",
                fontWeight: 700,
              }}
              shadow={[
                ["#FA00FF", 0],
                ["#B580FF", 5],
                ["#FFFFFF", 10],
                ["rgba(255,255,255,0.3)", 85],
                ["#4475F3", 100],
              ]}
            >
              DEPOSIT & EARN
            </PrimaryButton>
          </motion.div>
          <motion.div
            initial={{
              y: 20,
              opacity: 0,
            }}
            animate={{ y: isInView ? 0 : 20, opacity: isInView ? 1 : 0 }}
            transition={{ duration: 0.2, delay: 0.9 }}
          >
            <TypographyGradient
              ml={1}
              fontWeight={700}
              gradient="linear-gradient(90deg,#AA3AF6,#FDA9E5)"
              sx={{
                fontStyle: "italic",
                fontSize: { xs: 15, sm: 18, lg: 20 },
                cursor: 'pointer'
              }}
              onClick={() => window.open('https://docs.flaex.io/', '_blank')}
            >
              LEARN MORE
            </TypographyGradient>
          </motion.div>
        </Stack>
        <motion.div
          initial={{
            transform: `translateX(150vw) scaleY(0)`,
            opacity: 0,
          }}
          animate={{
            transform: `translateX(${isInView ? 0 : 150}vw) scaleY(${isInView ? 1 : 0
              })`,
            opacity: isInView ? 1 : 0,
          }}
          transition={{
            type: "spring",
            stiffness: 700,
            damping: 30,
            delay: 0.5,
          }}
        >
          <FlexRowAlign gap={4} flexWrap={'wrap'}>
            <Typography color={"text.secondary"} textAlign={'center'} width={{ xs: '300px', md: 'fit-content' }}>BACKED BY</Typography>
            <img src="static/logo/AAVE.svg" style={{ height: 20 }} alt="aave" />
            <img
              src="static/logo/ANTLER.svg"
              style={{ height: 30 }}
              alt="antler"
            />
          </FlexRowAlign>
        </motion.div>
      </StyledContainer>
      <motion.div
        style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          top: 0,
          left: 0,
        }}
        initial={{
          filter: "blur(200px)",
        }}
        animate={{
          filter: `blur(${isInView ? 15 : 200}px)`,
        }}
        transition={{
          duration: 1,
        }}
      >
        <motion.img
          src="logo.svg"
          style={{
            width: "60vw",
            height: "60vh",
            position: "absolute",
            top: "calc(50% - 30vh)",
            left: "calc(50% - 30vw)",
            objectFit: "contain",
            zIndex: -1,
            opacity: 0.15,
            filter: "blur(15px)",
            transform: "scale(2)",
          }}
          animate={{
            rotate: [0, -360],
          }}
          transition={{
            duration: 20,
            ease: "linear",
            times: [0, 1],
            repeat: Infinity,
          }}
        />
      </motion.div>
      <Stack
        sx={{
          background: 'url("static/layouts/background-grid.svg")',
          height: "100%",
          width: "100%",
          position: "absolute",
          top: 0,
          left: 0,
          zIndex: -1,
        }}
      ></Stack>
      {/* <AppModal open={open} handleClose={() => setOpen(false)}>
        <Stack
          p={2}
          pt={4}
          alignItems={"center"}
          justifyContent={"center"}
          spacing={3}
          px={8}
        >
          <Typography variant="h6" fontWeight={700}>
            Choose the pool to deposit
          </Typography>
          <FlexBetween gap={3} width={"100%"}>
            <SecondaryButton>
              <FlexRowAlign gap={1} px={2} width={200}>
                <img
                  src="static/coins/usdc.svg"
                  style={{ width: 30, height: 30 }}
                  alt="usdc"
                />
                <Typography fontWeight={600}>USDC</Typography>
                <Box flexGrow={1} />
                <Typography variant="h6" fontWeight={600}>
                  6%
                </Typography>
              </FlexRowAlign>
            </SecondaryButton>
            <Button
              sx={{
                flexGrow: 1,
                background: theme.palette.background.gradient,
                height: 45,
                borderRadius: "0.5rem",
                textTransform: "uppercase",
                fontWeight: 600,
                fontStyle: "italic",
                fontSize: "1rem",
                color: "#000",
                paddingX: "1rem",
              }}
            >
              DEPOSIT to trading fund
            </Button>
          </FlexBetween>
          <FlexBetween gap={3} width={"100%"}>
            <SecondaryButton>
              <FlexRowAlign gap={1} px={2} width={200}>
                <img
                  src="static/coins/usdc.svg"
                  style={{ width: 30, height: 30 }}
                  alt="usdc"
                />
                <Typography fontWeight={600}>USDC</Typography>
                <Box flexGrow={1} />
                <Typography variant="h6" fontWeight={600}>
                  12.5%
                </Typography>
              </FlexRowAlign>
            </SecondaryButton>
            <Button
              sx={{
                flexGrow: 1,
                background: theme.palette.background.gradient,
                height: 45,
                borderRadius: "0.5rem",
                textTransform: "uppercase",
                fontWeight: 600,
                fontStyle: "italic",
                fontSize: "1rem",
                color: "#000",
                paddingX: "1rem",
              }}
            >
              DEPOSIT to capital provider
            </Button>
          </FlexBetween>
          <TypographyGradient
            ml={1}
            fontWeight={700}
            gradient="linear-gradient(90deg,#AA3AF6,#FDA9E5)"
            sx={{
              fontStyle: "italic",
            }}
          >
            LEARN MORE
          </TypographyGradient>
        </Stack>
      </AppModal> */}
    </Section>
  );
};

const StyledContainer = styled(Stack)(({ theme }) => ({
  height: "100vh",
  alignItems: "center",
  justifyContent: "center",
}));
